import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BaseURL } from "./Api";

export interface FooterConfigData {
  id: number;
  source: string;
  background_color: string;
  text_color: string;
  socials: {
    id: string;
    platform: string;
    url: string;
    icon: string;
    order: number;
  }[];
  contact_details: {
    id: string;
    type: "email" | "phone" | "address";
    value: string;
    order: number;
  }[];
  app_links: {
    id: string;
    platform: "android" | "ios";
    url: string;
    label: string;
    order: number;
  }[];
}

export const footerConfigApi = createApi({
  reducerPath: "footerConfigApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${BaseURL.replace(/\/+$/, "")}/api/configurations/`,
  }),
  tagTypes: ["FooterConfig"],
  endpoints: (builder) => ({
    getFooterConfig: builder.query<FooterConfigData | null, string>({
      query: (source) => `footer-config/?source=${encodeURIComponent(source)}`,
      transformResponse: (res: FooterConfigData[], _meta, source) =>
        res.find((c) => c.source === source) ?? null,
      providesTags: (_result, _error, source) => [
        { type: "FooterConfig", id: source },
      ],
    }),
    saveFooterConfig: builder.mutation<
      FooterConfigData,
      {
        id: number | null;
        body: Partial<FooterConfigData> & { source: string };
      }
    >({
      query: ({ id, body }) => ({
        url: id ? `footer-config/${id}/` : `footer-config/`,
        method: id ? "PATCH" : "POST",
        body,
      }),
      invalidatesTags: (_result, _error, { body }) => [
        { type: "FooterConfig", id: body.source },
      ],
    }),
  }),
});

export const { useGetFooterConfigQuery, useSaveFooterConfigMutation } =
  footerConfigApi;
